import FlexibleLink from 'src/components/ui/FlexibleLink/FlexibleLink'
import { Image } from 'src/components/ui/Image'

interface CartaoPresenteInfoProps {
  title: string
  description: string
  extraText: string
  buttonText: string
  buttonLink: string
  image: string
  backgroundColor?: string
}

const CartaoPresenteInfo: React.FC<CartaoPresenteInfoProps> = ({
  title,
  description,
  extraText,
  buttonText,
  buttonLink,
  image,
  backgroundColor = '#F6F7F8',
}) => {
  return (
    <section
      className="w-full max-w-[1440px] flex-col-reverse mx-auto flex md:flex-row items-center justify-between gap-8 px-6 py-12 rounded-lg"
      style={{ backgroundColor }}
    >
      <div className="flex flex-col md:pl-24 items-start max-w-lg space-y-4">
        <h2 className="text-4xlxl md:text-3xl font-bold text-[#101010]">
          {title}
        </h2>
        <p className="text-[15181B] leading-6 text-base">{description}</p>
        {extraText && (
          <p className="text-gray-600 text-sm leading-relaxed">{extraText}</p>
        )}
        <FlexibleLink
          linkUrl={buttonLink}
          classNames="inline-block md:mt-12 px-6 py-3 w-full md-[318px] h-[60px] content-center text-center rounded-full bg-[#3643BA] text-white font-medium"
          label={buttonText}
        />
      </div>

      <div className="flex justify-center items-center flex-1">
        <Image
          preload
          src={image}
          alt="Cartão Presente Decathlon"
          className="w-full max-w-md object-contain"
        />
      </div>
    </section>
  )
}

export default CartaoPresenteInfo
